import Hotspot from '../hotspot/hotspot'
import classNames from 'classnames'
import './styles.scss'

function ExteriorAngle({ imgSrc, hotspots }) {
  return (
    <div className="exterior-angle">
      <div className="exterior-angle__content">
        <div
          className={classNames({
            'virtual-tour-image': true,
            'use-width': true,
          })}
        >
          <img
            className="exterior-angle__img"
            src={imgSrc}
          />
          {hotspots.map((hotspot, index) => (
            <Hotspot
              key={index}
              hotspot={hotspot}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default ExteriorAngle
